import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../_services';
import { Member } from '../../../_models';

@Component({
  selector: 'app-rf',
  templateUrl: './rf.component.html',
  styleUrls: ['./rf.component.scss']
})
export class RfComponent implements OnInit {
  currentMember: Member;
  constructor(private apiService: ApiService) {
    this.currentMember =  JSON.parse(localStorage.getItem("currentMember"));

   }

  ngOnInit() {
  }

  login(){
    this.apiService.ssoRFLogin(this.currentMember.memberId, this.currentMember.currentProductId).subscribe(r=>{
            
      $('body').append('<form target="_blank" action="' + r.url + '" method="post" id="postToIframe"></form>');
      $('#postToIframe').append('<input type="hidden" name="UID" value="'+ r.uid + '" />');
      $('#postToIframe').append('<input type="hidden" name="site_id" value="' + r.siteId + '" />');
      $('#postToIframe').submit().remove();
    }, err=>{
        console.log(err)
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/home/benefits/rf/rf.component.ts